/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import clsx from 'clsx'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()

  const currentYear = new Date().getFullYear()

  return (
    <div className={'footer py-4 d-flex flex-lg-column'} id='kt_footer'>
      {/*begin::Container*/}
      <div className={clsx(classes.footerContainer, 'd-flex flex-column flex-md-row justify-content-center')}>
        {/*begin::Copyright*/}
        <div className='text-dark'>
          <span className='text-gray-400 fw-bold'>© {currentYear} Mogul Clients, LLC. All rights reserved.</span>
        </div>
        {/*end::Copyright*/}
      </div>
      {/*end::Container*/}
    </div>
  )
}

export { Footer }
